import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { UserStateInfo } from './client-api.service';
import { UserService } from './core-services/user.service';
import { GLOBAL, IGlobalSettings } from './shared/global-settings';
import { environment } from 'src/environments/environment';
import { SystemConfigService } from './core-services/system-config.service';
import { OrganizationService } from './core-services/organization.service';
import { AccountSplitService } from './admin/maintenance/management-fee-splits/services/account-splits.service';
import { SubsManager } from './shared/tcc-ui/subs-manager';
import { AppInsightsRef } from './shared/tcc-ui/app-insights';
import { AuthService } from './auth/auth.service';
import { NavbarMessageService } from './shared/navbar-message';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy, OnInit {
  private subsMgr = new SubsManager();
  env = environment;
  
  hideNav = false;
  navBarMessage = this.navbarMessageService.getMessage();
  state: 'loading' | 'ready' = 'loading';
  userChangeSubject = new BehaviorSubject<UserStateInfo | undefined>(undefined);
  systemConfig$ = this.systemConfigService.systemConfig$;  

  constructor(
    @Inject(GLOBAL) public globalSettings: IGlobalSettings,
    private accountSplitService: AccountSplitService,    
    private aiSvc: AppInsightsRef,
    private router: Router,
    private systemConfigService: SystemConfigService,
    private userSvc: UserService,
    private orgainzationService: OrganizationService,
    private navbarMessageService: NavbarMessageService
  ) {
    this.systemConfigService.setSystemConfig();    
  }

  ngOnInit() {
    this.state = 'loading';

    if (window.self !== window.top) {
      // this is page has been loaded in an iframe.  Possible because it is handling the login response.
      return;
    }

    this.orgainzationService.setOrganizations();
    this.accountSplitService.setAccountSplits();
    this.accountSplitService.setManagementFeeAccountSplits();
   
    this.subsMgr.addSub = this.userSvc.currentUser$.pipe(
      filter((u): u is Required<UserStateInfo> => !!u?.email),
      tap(u => this.aiSvc.appInsights?.setAuthenticatedUserContext(u.email))
    ).subscribe((u) => {        
        this.userChangeSubject.next(u);
      },
      err => {
        alert('Error Authenticating');
      });

    // set to ready once the first navigation event completes.
    this.subsMgr.addSub = this.router.events.pipe(
      filter((e: Event) => e instanceof NavigationEnd),
      tap(() => this.state = 'ready'),
      take(1)
    ).subscribe();

    // Hide the side navigation when specified by the current route.
    this.subsMgr.addSub = this.router.events.pipe(
      filter((e: Event) => e instanceof NavigationEnd),
      tap(() => {
        this.hideNav = (this.router.routerState.root)
          ? this.router.routerState.root.firstChild?.snapshot.data.hideNavOptions || false
          : false;
      })
    ).subscribe();

    // when the user and Ai context is set then set the authenticatedId on the context to the user email
    this.subsMgr.addSub = this.userChangeSubject
      .pipe(filter((u) => u! && true), take(1))
      .subscribe(u => this.aiSvc.appInsights?.setAuthenticatedUserContext(u!.email));
  }

  ngOnDestroy() {
    this.subsMgr.onDestroy();
  }

}
